export default "__VITE_ASSET__M4v44q8E__"